import script from "./HomeWork.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeWork.vue?vue&type=script&setup=true&lang=js"

import "./HomeWork.vue?vue&type=style&index=0&id=4d5aaec6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d5aaec6"]])

export default __exports__